import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarPinState,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CodeIcon from '@material-ui/icons/Code';
import BugReportIcon from '@material-ui/icons/BugReport';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

function PinToggle() {
  const { isPinned, toggleSidebarPinState } = useSidebarPinState();
  return (
    <SidebarItem
      icon={isPinned ? ChevronLeftIcon : ChevronRightIcon}
      text={isPinned ? 'Collapse' : 'Expand'}
      onClick={toggleSidebarPinState}
    />
  );
}

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:app-visualizer'); // Dev tool, not for end users
      nav.take('page:catalog-graph'); // Custom placement below
      nav.take('page:app/services-overview'); // Custom placement below

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem icon={HomeIcon} to="/" text="Home" />
            {nav.take('page:catalog')}
            <SidebarItem
              icon={BubbleChartIcon}
              to="/catalog-graph?rootEntityRefs[]=component:default/gameclientwsapi&maxDepth=2&selectedKinds[]=system&selectedKinds[]=api&selectedKinds[]=component&selectedKinds[]=resource&selectedRelations[]=apiConsumedBy&selectedRelations[]=apiProvidedBy&selectedRelations[]=childOf&selectedRelations[]=consumesApi&selectedRelations[]=dependencyOf&selectedRelations[]=dependsOn&selectedRelations[]=hasMember&selectedRelations[]=memberOf&selectedRelations[]=ownedBy&selectedRelations[]=ownerOf&selectedRelations[]=parentOf&selectedRelations[]=providesApi&unidirectional=true&mergeRelations=true&direction=LR&showFilters=true&curve=curveMonotoneX"
              text="System Graph"
            />
            <SidebarItem
              icon={DashboardIcon}
              to="/grafana-overview"
              text="Monitoring"
            />
            <SidebarItem
              icon={CodeIcon}
              to="/proto-browser"
              text="Proto Browser"
            />
            <SidebarItem
              icon={BugReportIcon}
              to="/error-reporting"
              text="Errors"
            />
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <PinToggle />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
